<template>
  <div>
    <a-toolbar
      class="pl-4"
      :class="{
        'primary-gradient': section !== 'calendar',
        'grey-gradient': section === 'calendar',
      }"
    >
      <v-icon left :dark="section !== 'calendar'"> mdi-label-variant </v-icon>
      <span class="widget-title">{{ $t("meetings") }}</span
      >&nbsp;
      <span class="widget-title">({{ btnLabel }})</span>
      <v-spacer></v-spacer>
      <meeting-filter @isLoader="isLoader"></meeting-filter>
    </a-toolbar>
    <v-card
      color="Neutral"
      :elevation="section === 'calendar' ? 1 : 0"
      class="meeting-card overflow-y-auto"
      :style="section === 'calendar' ? 'height: 750px' : ''"
    >
      <v-card-text>
        <v-skeleton-loader v-if="isSkeleton" type="article"></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="meetinglist"
          :page.sync="page"
          :items-per-page="5"
          :loading="isloading"
          :loading-text="loadtext"
          :footer-props="{
            'items-per-page-text': $t('lblRowsPerPage'),
          }"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.id"
                cols="12"
                sm="12"
                md="12"
                lg="12"
                style="padding: 10px"
              >
                <meeting-card :meetingObj="item"></meeting-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MeetingCard from "./MeetingCard.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import SignalRMixin from "../../mixin/SignalRMixin";
import MeetingFilter from "@/components/agenda/MeetingFilter.vue";
import AToolbar from "../../wrapper-component/AToolbar.vue";

export default {
  name: "UpcomingMeetingList",
  mixins: [SignalRMixin],
  props: {
    section: {
      type: String,
      default: "dashboard",
    },
  },
  data() {
    return {
      dateOptions: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      page: 1,
      isloading: true,
      isSkeleton: true,
    };
  },
  components: {
    MeetingCard,
    MeetingFilter,
    AToolbar,
  },
  computed: {
    ...mapState({
      meetingListData: (state) => state.meeting.meetingsList,
      meetingDetails: (state) => state.meeting.meetingDetails,
      meetingFilterData: (state) => state.meeting.default_meetting_filter,
    }),
    ...gettersMap(),
    sectionTitle() {
      if (this.default_filter == "month") {
        return "Current Month Meetings";
      } else if (this.default_filter == "quarter") {
        return "Current Quarter Meetings";
      } else if (this.default_filter == "year") {
        return "Current Year Meetings";
      } else if (this.default_filter == "custom") {
        var c_dates = this.custom_dates;
        // var date_arr = c_dates.split(",");
        return (
          this.custom_dates[0] +
          (this.custom_dates[1] ? ` To ${this.custom_dates[1]}` : "")
        );
      }
    },
    btnLabelText() {
      if (this.meetingFilterData.filter_type == "upcoming") {
        return this.$t("agenda.lbShowUpcoming");
      } else if (this.meetingFilterData.filter_type == "month") {
        return this.$t("agenda.lbPastMonth");
      } else if (this.meetingFilterData.filter_type == "quarter") {
        return this.$t("agenda.lbPastQuarter");
      } else if (this.meetingFilterData.filter_type == "year") {
        return this.$t("agenda.lbPastYear");
      } else if (this.meetingFilterData.filter_type == "custom") {
        return this.$t("agenda.lbCustom");
      } else {
        return this.$t("agenda.lbPastMonth");
      }
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    getLocalToDateFormat() {
      return new Intl.DateTimeFormat(
        this.selectedLang,
        this.dateOptions
      ).format(new Date(this.meetingFilterData.start_date));
    },
    getLocalFromDateFormat() {
      return new Intl.DateTimeFormat(
        this.selectedLang,
        this.dateOptions
      ).format(new Date(this.meetingFilterData.end_date));
    },
    btnLabel() {
      return this.meetingFilterData.filter_type == "upcoming"
        ? this.$t("agenda.lbShowUpcoming")
        : `${this.getLocalToDateFormat} ${this.$t("lblTo")} ${
            this.getLocalFromDateFormat
          }`;
    },
    showButtonTitle() {
      if (this.default_filter == "month") {
        return "Current Month";
      } else if (this.default_filter == "quarter") {
        return "Current Quarter";
      } else if (this.default_filter == "year") {
        return "Current Year";
      } else if (this.default_filter == "custom") {
        var c_dates = this.custom_dates;
        // var date_arr = c_dates.split(",");
        return (
          this.custom_dates[0] +
          (this.custom_dates[1] ? ` To ${this.custom_dates[1]}` : "")
        );
      }
    },
    meetinglist() {
      const data = this.meetingListData.map((item) => ({
        ...item,
        title: item.meetingName,
        meetingType: this.meetingTypesList.find(
          (c) =>
            String(c.label).toLowerCase() ===
            String(item.meetingType).toLowerCase()
        ) || { id: item.id, label: item.meetingType, color: "#F5CBA7" },
      }));

      data.sort(function (a, b) {
        return (
          new Date(a.scheduletStartTimeInUTC) -
          new Date(b.scheduletStartTimeInUTC)
        );
      });
      return data.filter((item) => {
        if (
          this.$security.checkMeetingTypeAccess(
            item.meetingType.id,
            "ViewMeeting"
          )
        ) {
          return item;
        }
      });
      // return data;
    },
    loadtext() {
      this.isloading = true;
      return this.meetinglist.length > 0
        ? this.$t("LoaderText")
        : this.$t("noData");
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
  },
  mounted() {
    setTimeout(() => {
      const childCard = document.getElementsByClassName("meeting-card");
      if (childCard.length > 0 && this.section !== "calendar") {
        const height = childCard[0].parentElement.parentElement.offsetHeight;
        if (height) {
          childCard[0].style.height = `${height - 48}px`;
        }
      }
    }, 500);
    this.signalRInit(`meeting_${this.selectedTenant}`);
  },
  async created() {
    await this.setDefaultFilterApi();
    // await this.getMeetingListApi();
    this.isSkeleton = false;
  },
  methods: {
    ...mapActions({
      widgetToggleApi: "widget/widgetToggle",
      getMeetingListApi: "meeting/getMeetingList",
      setDefaultFilterApi: "meeting/setDefaultFilterType",
    }),
    onCloseIconHandler(event) {
      this.widgetToggleApi({
        id: event.target.offsetParent.closest(".e-panel").id,
        isShow: false,
      });
    },
    signalRInit(target) {
      this.signalConnection.on(target, async (message) => {
        if (message) {
          try {
            await this.getMeetingListApi();
          } catch (error) {
             console.log(error, "API error");
          }
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
    isLoader(status) {
      this.isSkeleton = status;
    },
  },
};
function gettersMap() {
  return mapGetters({
    categoriesList: "tenant/agendaCategories",
    meetingTypesList: "tenant/agendaMeetingTypes",
    getFilteredResultApi: "meeting/getFilteredResult",
  });
}
</script>